import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ObservationVariable } from '../../../shared/model/observation-variable.model';
import { ObservationUnitsSearchResponse } from '../../../shared/dataset/model/observation-units-search-response.model';
import { VariableTypeEnum } from '../../../shared/ontology/variable-type.enum';
import { CategoricalMatchByEnum, GenericDatasetComponent } from './generic-dataset.component';
import { VariableDetails } from '../../../shared/ontology/model/variable-details';
import { StudyEditorContext } from '../../study-editor.context';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Principal } from '../../../shared';
import { ActivatedRoute } from '@angular/router';
import { DatasetService } from '../../../shared/dataset/service/dataset.service';
import { ObservationUnitsSearchFilter, ObservationUnitsSearchRequest } from '../../../shared/dataset/model/observation-units-search-request.model';
import {
    ADD_OBSERVATION_SELECTION_VARIABLES_PERMISSIONS,
    ADD_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS,
    DELETE_SUB_OBSERVATION_UNITS_PERMISSIONS,
    EDIT_SUB_OBSERVATION_UNITS_NUMBER_PERMISSIONS,
    MANAGE_ACCEPT_PENDING_OBSERVATION_VALUES_PERMISSIONS,
    MANAGE_CONFIRMED_OBSERVATION_VALUES_PERMISSIONS,
    MANAGE_PENDING_OBSERVATION_VALUES_PERMISSIONS,
    MODIFY_COLUMNS_PERMISSIONS,
    MS_MANAGE_FILES_OBSERVATIONS_PERMISSION,
    RENAME_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS,
    VIEW_GERMPLASM_DETAILS_PERMISSION,
    VIEW_NAMES_PERMISSION
} from '../../../shared/auth/permissions';
import { Cell, ObservationUnitData } from '../../../shared/dataset/model/observation-unit-data.model';
import { GermplasmDetailsPopupService } from '../../../germplasm-details/germplasm-details-popup.service';
import { DatasetVariable, DatasetVariableOrder } from '../../../shared/study/model/dataset-variable';
import { AlertService } from '../../../shared/alert/alert.service';
import { StudyInstanceModel } from '../../../shared/dataset/model/study-instance.model';
import { BreedingMethod } from '../../../shared/breeding-method/model/breeding-method';
import { BreedingMethodFilterTypeEnum } from '../../../shared/breeding-methods-select/breeding-methods-select.component';
import { AcceptPendingModalComponent } from '../../shared/modals/accept-pending-modal/accept-pending-modal.component';
import { DATASET_TYPES_OBSERVATION_IDS, DatasetTypeEnum } from '../../../shared/dataset/model/dataset-type.enum';
import { DerivedVariableService } from '../../shared/services/derived-variable.service';
import { ModalConfirmComponent } from '../../../shared/modal/modal-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { DatasetModel } from '../../../shared/dataset/model/dataset.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ColumnData } from '../../shared/models/column-data.model';
import { ColumnDataService } from '../../shared/services/column-data.service';
import { ObservationVariableItem } from '../../shared/models/observation-variable-item.model';
import { StudyEditorService } from '../../study-editor.service';
import { LotCreationDialogComponent } from '../../../germplasm-manager/inventory/lot-creation-dialog.component';
import { StudyDatasetContext } from './study-dataset.context';
import { SubscriptionsManager } from '../../../shared/util/subscriptions-manager';
import { SearchOrigin } from '../../../shared/model/Search-origin-composite';
import { FileManagerComponent } from '../../../file-manager/file-manager.component';
import { FileService } from '../../../shared/file/service/file.service';
import { DateHelperService } from '../../../shared/service/date.helper.service';
import { ObservationDetailsModalComponent } from '../../../entities/observation/observation-details-modal.component';
import { ObservationSampleDetailsModalComponent } from '../../shared/modals/observation-sample-details-modal/observation-sample-details-modal.component';
import { PlantingPreparationModalComponent } from '../../shared/modals/planting-preparation-modal/planting-preparation-modal.component';
import { ChangePlotEntryModalComponent } from '../../shared/modals/change-plot-entry-modal/change-plot-entry-modal.component';
import { PlotVisualizationModalComponent } from '../../shared/modals/plot-visualization-modal/plot-visualization-modal.component';
import { COLUMN_SELECTOR_CHECKBOX_ID, ColumnSelectorComponent } from './column-selector/column-selector.component';
import { HELP_MANAGE_STUDIES_SUB_OBSERVATIONS } from '../../../app.constants';
import { preventDefaultOnShiftKey } from '../../../field-management/utils';
import { getStaticColumnLabelKey } from '../../../shared/util/static-columns-util';
import { take } from 'rxjs/operators';
import { EditVariableAliasModalComponent } from '../../shared/modals/edit-variable-alias-modal/edit-variable-alias-modal.component';
import { SubObservationInfoModel } from './sub-observation-unit-dataset-builder/sub-observation-info.model';
import { UpdateSubObservationUnitNumberModalComponent } from './update-sub-observation-unit-number/update-sub-observation-unit-number-modal.component';
import { DomEvent } from 'leaflet';

@Component({
    selector: 'jhi-study-dataset',
    templateUrl: './study-dataset.component.html',
    styleUrls: [
        './study-dataset.component.scss'
    ]
})
export class StudyDatasetComponent extends GenericDatasetComponent implements OnInit, OnDestroy, AfterViewChecked {


    @ViewChild('bookmark', { static: false }) bookmark: ElementRef;
    @ViewChild(ColumnSelectorComponent) columnSelectorComponent!: ColumnSelectorComponent;

    DELETE_SUB_OBSERVATION_UNITS_PERMISSIONS = DELETE_SUB_OBSERVATION_UNITS_PERMISSIONS;
    EDIT_SUB_OBSERVATION_UNITS_NUMBER_PERMISSIONS = EDIT_SUB_OBSERVATION_UNITS_NUMBER_PERMISSIONS;

    public readonly BreedingMethodFilterTypeEnum = BreedingMethodFilterTypeEnum;
    public readonly CategoricalMatchByEnum = CategoricalMatchByEnum;

    protected readonly MANAGE_ACCEPT_PENDING_OBSERVATION_VALUES_PERMISSIONS = MANAGE_ACCEPT_PENDING_OBSERVATION_VALUES_PERMISSIONS;
    protected readonly MANAGE_PENDING_OBSERVATION_VALUES_PERMISSIONS = MANAGE_PENDING_OBSERVATION_VALUES_PERMISSIONS;
    protected readonly MANAGE_CONFIRMED_OBSERVATION_VALUES_PERMISSIONS = MANAGE_CONFIRMED_OBSERVATION_VALUES_PERMISSIONS;
    protected readonly MANAGE_FILES_OBSERVATIONS_PERMISSION = MS_MANAGE_FILES_OBSERVATIONS_PERMISSION;
    protected readonly HELP_MANAGE_STUDIES_SUB_OBSERVATIONS = HELP_MANAGE_STUDIES_SUB_OBSERVATIONS;
    protected readonly ADD_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS = ADD_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS;
    protected readonly ADD_OBSERVATION_SELECTION_VARIABLES_PERMISSIONS = ADD_OBSERVATION_SELECTION_VARIABLES_PERMISSIONS;
    protected readonly RENAME_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS = RENAME_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS;
    protected readonly STATIC_COLUMN_CHECKBOX = COLUMN_SELECTOR_CHECKBOX_ID;
    protected readonly preventDefaultOnShiftKey = preventDefaultOnShiftKey;
    protected readonly getStaticColumnLabelKey = getStaticColumnLabelKey;

    hasViewGermplasmDetailsPermission = true;

    HIDE_FROM_VARIABLES_TABLE: number[] = [];

    traitVariables: ObservationVariableItem[] = [];
    selectionVariables: ObservationVariableItem[] = [];

    traitsColumns: ColumnData[] = [];
    selectionsColumns: ColumnData[] = [];
    entryDetailsColumns: ColumnData[] = [];
    otherColumns: ColumnData[] = [];
    batchVariables: ColumnData[] = [];
    selectedBatchVariable: ColumnData;
    batchVariablesFilter: ObservationUnitsSearchFilter;
    scrollIntoView = false;
    displayedColumns: ColumnData[] = [];
    currentDataset: DatasetModel;
    environments: StudyInstanceModel[] = [];
    selectedEnvironment: StudyInstanceModel;
    selectedStatusFilter: number = 1;
    isCollapsedTraits: boolean = false;
    isCollapsedSelections: boolean = false;
    currentContextMenu: NgbPopover;
    currentContextMenuData: { row: number, col: number, model: ObservationUnitData, entry: ObservationUnitsSearchResponse, column: ColumnData };
    isStudyHasCalculatedVariables: boolean;
    moveVariableTimeout: any;
    isVariableMoving: boolean;
    isFileStorageConfigured: boolean;
    hoveredRow: number | null = null;

    subscriptionManager = new SubscriptionsManager();
    cancellableSubscription = new SubscriptionsManager();
    // Add a promise queue to track pending addVariable operations
    private addVariablePromises = new Set<Promise<void>>();

    subObservationVariables = [8206, 8207, 8205];
    subObservationInfoModels: SubObservationInfoModel[] = [{
        id: DatasetTypeEnum.PLANT_SUBOBSERVATIONS,
        label: 'study-editor.dataset.label-plants',
        name: 'plants',
        defaultVariableId: 8206,
        alias: 'plants'
    }, {
        id: DatasetTypeEnum.QUADRAT_SUBOBSERVATIONS,
        label: 'study-editor.dataset.label-quadrats',
        name: 'quadrats',
        defaultVariableId: 8207,
        alias: 'quadrats'
    }, {
        id: DatasetTypeEnum.TIME_SERIES_SUBOBSERVATIONS,
        label: 'study-editor.dataset.label-time-series',
        name: 'time series',
        defaultVariableId: 8205,
        alias: 'time points'
    }, {
        id: DatasetTypeEnum.CUSTOM_SUBOBSERVATIONS,
        label: 'study-editor.dataset.label-custom',
        name: 'sub-observation units',
        defaultVariableId: undefined,
        alias: 'sub-observation units'
    }];


    constructor(private activaedRoute: ActivatedRoute,
                protected translateService: TranslateService,
                private datasetService: DatasetService,
                public studyEditorContext: StudyEditorContext,
                protected modalService: NgbModal,
                protected principal: Principal,
                protected germplasmDetailsPopupService: GermplasmDetailsPopupService,
                private alertService: AlertService,
                private derivedVariableService: DerivedVariableService,
                private studyEditorService: StudyEditorService,
                private studyDatasetContext: StudyDatasetContext,
                private fileService: FileService,
                private dateHelperService: DateHelperService) {
        super(studyEditorContext, modalService, translateService, principal);
    }

    ngAfterViewChecked(): void {
        if (this.bookmark && this.scrollIntoView) {
            this.bookmark.nativeElement.scrollIntoView();
            this.bookmark.nativeElement.focus();
            this.scrollIntoView = false;
        }
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
        this.cancellableSubscription.unsubscribeAll();
    }

    ngOnInit() {

        this.subscriptionManager.add = this.activaedRoute.paramMap.subscribe(async params => {

            this.hasViewGermplasmDetailsPermission = this.principal.hasAnyAuthorityDirect(VIEW_GERMPLASM_DETAILS_PERMISSION);

            this.resetState();

            // When the datasetId is changed, make sure to reload the data.
            const datasetId: number = Number(params.get('datasetId'));
            await this.loadDataset(datasetId);

            const allEnvironments = new StudyInstanceModel();
            allEnvironments.instanceId = -1;
            allEnvironments.locationName = this.translateService.instant('study-editor.all-environments');
            this.environments = [allEnvironments, ...this.currentDataset.instances];
            if (this.currentDataset.hasPendingData) {
                this.selectedEnvironment = this.environments[0];
                this.isPendingView = true;
            } else {
                this.selectedEnvironment = this.environments[1];
            }

            this.displayExecuteCalculateVariableMenu(this.studyEditorContext.studyId);

            this.isFileStorageConfigured = await this.fileService.isFileStorageConfigured();

            this.columnDataService = new ColumnDataService(ColumnDataService.STUDY_DATASET_KEY, String(this.currentDataset.datasetId));

            super.ngOnInit();
        });

        this.subscriptionManager.add = this.studyDatasetContext.createLots$.subscribe(async(lot) => {
            this.openLotCreationModal();
        });

        this.subscriptionManager.add = this.studyDatasetContext.plantingInventory$.subscribe(async(lot) => {
            this.openPlantingInventoryModal();
        });

        this.subscriptionManager.add = this.studyDatasetContext.changePlotEntry$.subscribe(async(lot) => {
            this.openChangePlotEntryModal();
        });

    }

    async loadDataset(datasetId: number) {
        const datasetResponse =
            await this.datasetService.getDataset(this.studyEditorContext.studyDetails.id, datasetId).pipe(take(1)).toPromise();

        this.currentDataset = datasetResponse.body;
        this.studyEditorContext.updateDataset(this.currentDataset);

        this.traitVariables = this.currentDataset.variables
            .filter(v => VariableTypeEnum[v.variableType] === VariableTypeEnum.TRAIT)
            .map(v => v as ObservationVariableItem);

        this.selectionVariables = this.currentDataset.variables
            .filter(v => VariableTypeEnum[v.variableType] === VariableTypeEnum.SELECTION_METHOD)
            .map(v => v as ObservationVariableItem);
    }


    async loadTable(): Promise<void> {
        if (this.hasGeneratedDesign()) {
            await this.loadTableHeader();
            this.loadTableData();
        }
    }

    async loadTableHeader(): Promise<void> {

        const response = await
        this.datasetService.getObservationSetColumns(
            this.studyEditorContext.studyDetails.id,
            this.currentDataset.datasetId,
            this.isPendingView).pipe(take(1)).toPromise();

        let columnsFromResponse = response.body as ColumnData[];
        columnsFromResponse.forEach(column => {
            column.visible = true;
            column.selected = true;
            column.columnSelectorVisible = true;
        });
        columnsFromResponse.unshift({
            alias: '',
            factor: true,
            name: 'FILES',
            termId: this.STATIC_COLUMN_FILES,
            displayName: 'FILES',
            visible: this.isFileStorageConfigured,
            columnSelectorVisible: this.isFileStorageConfigured,
            selected: this.isFileStorageConfigured,
            variableTypeId: 0,
            id: this.STATIC_COLUMN_FILES,
            possibleValuesById: undefined,
            possibleValuesByName: undefined,
            enableFilterSorting: false,
            deletable: false,
            hidden: false,
            inputVariables: '',
        });
        columnsFromResponse.unshift({
            alias: '',
            factor: true,
            name: '',
            termId: this.CHECKBOX,
            displayName: '',
            visible: true,
            columnSelectorVisible: true,
            selected: true,
            variableTypeId: 0,
            id: this.CHECKBOX,
            possibleValuesById: undefined,
            possibleValuesByName: undefined,
            enableFilterSorting: false,
            deletable: false,
            hidden: false,
            inputVariables: '',
        });

        // Hide ENTRY DETAILS columns by default
        // except for ENTRY_NO,  ENTRY_TYPE and ENTRY_CODE entry details columns.
        columnsFromResponse.forEach(column => {
            if (VariableTypeEnum[column.variableType] === VariableTypeEnum.ENTRY_DETAIL) {
                // Do not hide ENTRY_NO and ENTRY_TYPE entry details columns.
                if ([this.STATIC_COLUMN_ENTRY_NO, this.STATIC_COLUMN_ENTRY_TYPE, this.STATIC_COLUMN_ENTRY_CODE].includes(column.termId)) {
                } else {
                    // Hide ENTRY_DETAIL columns by default
                    column.selected = false;
                }
            }
        });

        // Hide OBS_UNIT_ID by default
        const obsUnitId = columnsFromResponse.find(column => column.termId === this.STATIC_COLUMN_OBS_UNIT_ID);
        if (obsUnitId) {
            obsUnitId.selected = false;
        }
        // Show only the sorting filter for all columns except for the specified columns
        columnsFromResponse.forEach(column => {
            column.enableFilterSorting = ![this.STATIC_COLUMN_FEMALE_PARENT_GID, this.STATIC_COLUMN_FEMALE_PARENT_NAME, this.STATIC_COLUMN_MALE_PARENT_GID, this.STATIC_COLUMN_MALE_PARENT_NAME].includes(column.termId);
        });
        this.displayedColumns = this.columnDataService.processColumns(columnsFromResponse, this.displayedColumns);
        this.displayedColumns = this.columnDataService.applyColumnsState();
        this.groupColumns(this.displayedColumns);
    }

    loadTableData(pageIndex: any = 1, pageSize: any = 50): void {
        const request: ObservationUnitsSearchRequest = new ObservationUnitsSearchRequest();
        request.instanceIds = this.getInstanceIds();
        request.draw = 'true';
        request.draftMode = this.isPendingView;
        request.filter = this.getFilter();
        request.visibleColumns = this.columnDataService.getVisibleColumns();
        request.datasetId = this.currentDataset.datasetId;

        const pagination: any = {
            page: pageIndex - 1,
            size: pageSize,
            sort: this.getSort(),
        };
        this.cancellableSubscription.add = this.datasetService.getObservationUnitTable(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, request, pagination).subscribe((response) => {
            this.numberOfItems = Number(response.headers.get('X-Total-Count'));
            this.numberOfFilteredItems = Number(response.headers.get('X-Filtered-Count'));
            this.items = response.body;
        });
    }

    async moveVariable(eventData: { selectedVariable: ObservationVariable, variableIdForSwitching: number, movement: 'up' | 'down' }, variableType: VariableTypeEnum) {
        this.isVariableMoving = true;
        if (this.currentDataset && eventData.selectedVariable) {
            if (this.moveVariableTimeout) {
                clearTimeout(this.moveVariableTimeout);
            }
            this.moveVariableTimeout = setTimeout(async() => {
                const variable = eventData.selectedVariable;
                const datasetVariableOrder: DatasetVariableOrder = {
                    studyId: this.studyEditorContext.studyDetails.id,
                    variableTypeId: variableType.valueOf(),
                    variableId: variable.termId,
                    variableIdForSwitching: eventData.variableIdForSwitching,
                    updateOrderToMoveUp: eventData.movement === 'up',
                };
                try {
                    await this.datasetService.updateStudyTraitsOrder(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, variable.termId, datasetVariableOrder).toPromise();
                    this.columnDataService.deleteColumnsStateForCurrentKey();
                } catch (errorResponse) {
                    // If there's an error in the backend when moving a variable. We must reload the dataset variables to revert the state.
                    this.scheduleDatasetReload();
                } finally {
                    this.isVariableMoving = false;
                }
                this.scheduleReload();
            }, this.reloadDelay);
        }
    }

    async onVariableSelectModalClosed() {
        // Wait for all pending addVariable operations to complete
        await Promise.all(this.addVariablePromises);

        // Schedule reload after all operations are complete
        this.scheduleDatasetReload();
        this.scheduleReload();

    }

    async addVariable(variable: VariableDetails, variableTypeId: VariableTypeEnum) {
        if (this.currentDataset) {
            const datasetVariable: DatasetVariable = {
                variableTypeId: variableTypeId,
                variableId: parseInt(variable.id, 10),
                studyAlias: variable.alias || variable.name
            };

            const promise = (async () => {
                try {
                    if (variableTypeId === VariableTypeEnum.TRAIT) {
                        await this.datasetService.addTraits(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, datasetVariable).toPromise();
                    } else if (variableTypeId === VariableTypeEnum.SELECTION_METHOD) {
                        await this.datasetService.addSelections(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, datasetVariable).toPromise();
                    }
                    this.showWarningIfDependenciesAreMissing(this.studyEditorContext.studyId, this.currentDataset.datasetId, datasetVariable.variableId);
                } catch (errorResponse) {
                }
            })();

            // Add promise to the queue
            this.addVariablePromises.add(promise);

            // Clean up completed promises
            promise.finally(() => this.addVariablePromises.delete(promise));

            return promise;

        }
    }

    async removeVariables(variables: ObservationVariable[], variableTypeId: VariableTypeEnum) {
        const variablesToDelete: number[] = variables.map(variable => variable.termId);
        if (variableTypeId === VariableTypeEnum.TRAIT) {
            await this.datasetService.removeTraits(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, variablesToDelete).toPromise();
        } else if (variableTypeId === VariableTypeEnum.SELECTION_METHOD) {
            await this.datasetService.removeSelections(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, variablesToDelete).toPromise();
        }
        // Schedule reload instead of immediate reload
        this.scheduleDatasetReload();
        this.scheduleReload();
    }

    async renameVariableAlias(selectedVariable: ObservationVariable) {
        if (this.currentDataset) {
            const confirmModalRef = this.modalService.open(EditVariableAliasModalComponent as Component);
            confirmModalRef.componentInstance.studyId = this.studyEditorContext.studyDetails.id;
            confirmModalRef.componentInstance.datasetId = this.currentDataset.datasetId;
            confirmModalRef.componentInstance.observationVariable = selectedVariable;
            confirmModalRef.result.then((observationVariable: ObservationVariable) => {
                // When a trait variable alias is renamed, reload the table to apply changes in trait column name.
                this.scheduleReload();
            }, () => {
            });
        }
    }

    async updateObservation(entry: ObservationUnitsSearchResponse, column: ColumnData): Promise<void> {

        const studyId = this.studyEditorContext.studyDetails.id;
        const currentCell = this.editingCell;
        const dataModel: ObservationUnitData = currentCell.model;
        const value = currentCell.model.value ?? null;
        const draftValue = currentCell.model.draftValue ?? null;
        const previousValue = currentCell.previousValue;
        const row = currentCell.row;
        const col = currentCell.col;

        const hasValue = value !== null;

        if ((!this.isPendingView && value === previousValue)
            || (this.isPendingView && draftValue === previousValue)) {
            return;
        }

        if (this.isPendingView) {
            if (this.validateValue(draftValue)) {
                this.alertService.error('study-editor.study-dataset.error.invalid-draft-value');
                currentCell.model.draftValue = previousValue;
                return;
            }
        } else {
            if (this.validateValue(value)) {
                this.alertService.error('study-editor.study-dataset.error.invalid-value');
                currentCell.model.value = previousValue;
                return;
            }
        }

        if (dataModel.observationId) {
            if (!hasValue && !this.isPendingView) {
                this.datasetService.deleteObservation(studyId, this.currentDataset.datasetId, entry.observationUnitId,
                    dataModel.observationId).toPromise().then(() => {
                    dataModel.value = null;
                    dataModel.observationId = null;
                    dataModel.displayValue = null;
                    (dataModel as Cell).status = null;
                });
                return;
            }

            const doContinue = await this.confirmOutOfBoundData(value, column, CategoricalMatchByEnum.NAME);
            if (!doContinue) {
                dataModel.value = previousValue;
                return;
            }

            this.datasetService.updateObservation(studyId, this.currentDataset.datasetId, entry.observationUnitId,
                dataModel.observationId, {
                    categoricalValueId: this.getCategoricalValueId(value, column),
                    value: value,
                    draftValue: draftValue,
                    draftMode: this.isPendingView,
                    variableId: column.termId
                }).toPromise().then((responseData) => {
                const currentObservationUnitData = entry.variables[column.name];
                currentObservationUnitData.status = null;
                currentObservationUnitData.status = responseData.status;
                currentObservationUnitData.displayValue = responseData.displayValue;
                currentObservationUnitData.displayDraftValue = responseData.displayDraftValue;
                this.checkOfOutSync(column.termId, entry);
            });
            return;
        }

        if (hasValue) {

            const doContinue = await this.confirmOutOfBoundData(value, column, CategoricalMatchByEnum.NAME);
            if (!doContinue) {
                dataModel.value = previousValue;
                return;
            }

            this.datasetService.addObservation(studyId, this.currentDataset.datasetId, entry.observationUnitId, {
                observationUnitId: entry.observationUnitId,
                categoricalValueId: this.getCategoricalValueId(value, column),
                variableId: dataModel.variableId,
                value: value,
                draftMode: this.isPendingView
            }).toPromise().then((responseData) => {
                entry.variables[column.name] = responseData;
                this.checkOfOutSync(column.termId, entry);
            });
            return;
        }
    }

    checkOfOutSync(termId: number, entry: ObservationUnitsSearchResponse) {
        // valueChanged
        if (this.columnDataService.columnDataByInputTermId[termId]) {
            this.columnDataService.columnDataByInputTermId[termId]?.forEach(targetColumnData => {
                const observationUnitData = entry.variables[targetColumnData.name];
                if (observationUnitData && observationUnitData.observationId) {
                    observationUnitData.status = 'OUT_OF_SYNC';
                }
            });
        }
    }

    trackRowsById(index: number, row: ObservationUnitsSearchResponse) {
        return row.trialInstance;
    }

    trackColumnsById(index: number, column: ColumnData) {
        return column.id;
    }

    concatAllColumns(): ColumnData[] {
        return [
            ...this.traitsColumns,
            ...this.selectionsColumns,
            ...this.otherColumns,
            ...this.entryDetailsColumns,
        ];
    }

    private groupColumns(columns: ColumnData[]): void {

        this.traitsColumns = [];
        this.selectionsColumns = [];
        this.otherColumns = [];
        this.entryDetailsColumns = [];
        this.batchVariables = [];

        columns.forEach((columnData) => {
            if (columnData.variableTypeId === VariableTypeEnum.TRAIT) {
                this.traitsColumns.push(columnData);
                this.batchVariables.push(columnData);
            } else if (columnData.variableTypeId === VariableTypeEnum.SELECTION_METHOD) {
                this.selectionsColumns.push(columnData);
                this.batchVariables.push(columnData);
            } else if (columnData.variableTypeId === VariableTypeEnum.ENTRY_DETAIL) {
                this.entryDetailsColumns.push(columnData);
            } else if (columnData.variableTypeId) {
                this.otherColumns.push(columnData);
            }
        });
    }

    isColumnEditable(column: ColumnData): boolean {

        if ((this.isPendingView && !this.principal.hasAnyAuthorityDirect(MANAGE_PENDING_OBSERVATION_VALUES_PERMISSIONS)) ||
            (!this.isPendingView && !this.principal.hasAnyAuthorityDirect(MANAGE_CONFIRMED_OBSERVATION_VALUES_PERMISSIONS))) {
            return false;
        }

        // Only TRAITS/SELECTION METHOD variables are editable
        return ((column?.variableTypeId === VariableTypeEnum.TRAIT || column?.variableTypeId === VariableTypeEnum.SELECTION_METHOD)
            && this.hasAnyAuthority(MODIFY_COLUMNS_PERMISSIONS) && !column.systemVariable);
    }

    getCellValue(entry: ObservationUnitsSearchResponse, column: ColumnData, valueProperty: 'value' | 'draftValue' | 'displayValue' | 'displayDraftValue' = 'value'): string {
        if (!entry?.variables || !column?.name) {
            return '';
        }

        if (column.termId === this.LOCATION_ID_TERM_ID) {
            return entry.variables[column.name].value;
        }

        const property = entry.variables[column.name];
        if (!property?.value && !property?.variableId) {
            return '';
        }

        return property[valueProperty];
    }

    getModel(column: ColumnData, entry: ObservationUnitsSearchResponse) {
        return entry.variables[column.name];
    }

    validateValue(value) {
        if (value === null || value === undefined) {
            return false;
        }
        const invalidChars = /[<>?|%]/;
        return invalidChars.test(value);
    }

    getFilter(): ObservationUnitsSearchFilter {
        const variableId = this.selectedBatchVariable && this.selectedBatchVariable.termId;
        return {
            byOutOfBound: this.selectedStatusFilter === 2 || null,
            byMissing: this.selectedStatusFilter === 3 || null,
            byOutOfSync: this.selectedStatusFilter === 4 || null,
            byOverwritten: this.selectedStatusFilter === 5 || null,
            variableId: variableId,
            variableHasValue: null,
            filteredValues: this.displayedColumns.reduce((map, column) => {
                column.isFiltered = false;

                if (this.isTextFilter(column)) {
                    return map;
                }

                if (column.possibleValues) {
                    column.possibleValues.forEach((value) => {
                        if (value.isSelectedInFilters) {
                            map[String(column.termId)] = [...(map[String(column.termId)] || []), value.name];
                        }
                    });
                    if (!map[String(column.termId)] && column.query) {
                        map[String(column.termId)] = [column.query];
                    }
                } else if (column.query) {
                    if (column.dataType === 'Date') {
                        map[String(column.termId)] = [this.dateHelperService.convertFormattedNgbDateToString(column.query as unknown as any, '')];
                    } else {
                        map[String(column.termId)] = [column.query];
                    }
                }

                if (map[String(column.termId)]) {
                    column.isFiltered = true;
                }
                return map;
            }, {} as Map<string, string[]>),
            filteredTextValues: this.displayedColumns.reduce((map, column) => {
                if (!this.isTextFilter(column)) {
                    return map;
                }
                if (column.query) {
                    map[String(column.termId)] = column.query;
                    column.isFiltered = true;
                }
                return map;
            }, {} as Map<string, string>),
            variableTypeMap: this.displayedColumns.reduce((map, column) => {
                map[String(column.termId)] = column?.variableType?.toString();
                return map;
            }, {} as Map<string, string>)
        };

    }

    isTextFilter(column: ColumnData): boolean {

        if (column.termId === this.STATIC_COLUMN_DESIGNATION
            || column.termId === this.STATIC_COLUMN_FEMALE_PARENT_GID || column.termId === this.STATIC_COLUMN_FEMALE_PARENT_NAME
            || column.termId === this.STATIC_COLUMN_MALE_PARENT_GID || column.termId === this.STATIC_COLUMN_MALE_PARENT_NAME) {
            return true;
        }

        // Factors like GID, GROUPGID, LINE_GID and TESTER_GID have 'Germplasm List' datatype but they should be treated as numeric
        if (column.termId === this.STATIC_COLUMN_GID || column.termId === this.STATIC_COLUMN_GROUPGID
            || column.termId === this.STATIC_COLUMN_LINE_GID || column.termId === this.STATIC_COLUMN_TESTER_GID) {
            return false;
        }

        if (column.dataTypeCode === 'C' || column.dataTypeCode === 'N'
            || column.dataTypeCode === 'D' || column.termId === this.STATIC_COLUMN_SAMPLES) {
            return false;
        }
        return true;
    }

    onEnvironmentChange($event: any) {
        this.selectedEnvironment = $event;
        this.scheduleReload();
    }

    onStatusFilterChange($event: any) {
        this.scheduleReload();
    }

    onApplyFilterSuccess() {
        if (this.isPendingView) {
            this.scheduleDatasetReload();
            this.scheduleReload();
        } else {
            this.selectedEnvironment = this.environments[1];
            this.scheduleReload();
        }
    }

    onBatchVariableChanged($event: ColumnData) {
        this.scrollIntoView = false;
        this.selectedBatchVariable = $event;
        this.batchVariablesFilter = this.getFilter();
    }

    onSelectedBreedingMethod($event: BreedingMethod) {
        if (this.editingCell) {
            this.editingCell.model.value = $event.code;
        }
    }

    changeView(isPendingView: boolean) {
        this.isPendingView = isPendingView;
        this.isCollapsedTraits = isPendingView;
        this.isCollapsedSelections = isPendingView;
        this.scheduleReload();
    }

    onAcceptValue() {
        if (this.currentContextMenuData && this.isPendingView) {

            let newValue, newDraftValue, newDraftCategoricalValueId;
            newDraftValue = newDraftCategoricalValueId = null;
            newValue = this.currentContextMenuData.model.draftValue;

            const observationId = this.currentContextMenuData.model.observationId;
            const observationUnitId = this.currentContextMenuData.entry.observationUnitId;

            this.datasetService.updateObservation(this.studyEditorContext.studyId, this.currentDataset.datasetId, observationUnitId, observationId, {
                categoricalValueId: newDraftCategoricalValueId,
                value: newValue,
                draftValue: newDraftValue,
                draftCategoricalValueId: newDraftCategoricalValueId,
                variableId: this.currentContextMenuData.column.termId
            }).toPromise().then((responseData: ObservationUnitData) => {
                const currentObservationUnitData = this.currentContextMenuData.entry.variables[this.currentContextMenuData.column.name];
                currentObservationUnitData.value = newValue;
                currentObservationUnitData.draftValue = newDraftValue;
                currentObservationUnitData.displayValue = responseData.displayValue;
                currentObservationUnitData.displayDraftValue = responseData.displayDraftValue;

                currentObservationUnitData.status = null;
                currentObservationUnitData.status = responseData.status;
                this.checkOfOutSync(this.currentContextMenuData.column.termId, this.currentContextMenuData.entry);
                this.scheduleTableDataReload(this.currentPage, this.pageSize);
            });

        }
    }

    onSetToMissing() {
        if (this.currentContextMenuData) {

            let newValue, newDraftValue, newDraftCategoricalValueId;
            newDraftValue = newDraftCategoricalValueId = null;
            newValue = this.MISSING_TEXT;

            if (this.isPendingView) {
                newDraftValue = newDraftCategoricalValueId = null;
            } else {
                newDraftValue = this.currentContextMenuData.model.draftValue;
                newDraftCategoricalValueId = this.currentContextMenuData.model.draftCategoricalValueId;
            }

            const observationId = this.currentContextMenuData.model.observationId;
            const observationUnitId = this.currentContextMenuData.entry.observationUnitId;

            this.datasetService.updateObservation(this.studyEditorContext.studyId, this.currentDataset.datasetId, observationUnitId, observationId, {
                categoricalValueId: this.getCategoricalValueId(newValue, this.currentContextMenuData.column),
                value: newValue,
                draftValue: newDraftValue,
                draftCategoricalValueId: newDraftCategoricalValueId,
                variableId: this.currentContextMenuData.column.termId
            }).toPromise().then((responseData) => {
                const currentObservationUnitData = this.currentContextMenuData.entry.variables[this.currentContextMenuData.column.name];
                this.currentContextMenuData.entry.variables[this.currentContextMenuData.column.name].value = newValue;

                if (this.isPendingView) {
                    currentObservationUnitData.draftValue = null;
                    currentObservationUnitData.value = null;
                }
                currentObservationUnitData.status = null;
                currentObservationUnitData.status = (responseData as Cell).status;
                currentObservationUnitData.displayValue = responseData.displayValue;
                currentObservationUnitData.displayDraftValue = responseData.displayDraftValue;
                this.checkOfOutSync(this.currentContextMenuData.column.termId, this.currentContextMenuData.entry);
                this.scheduleTableDataReload(this.currentPage, this.pageSize);
            });

        }
    }

    showContextMenu(entry: ObservationUnitsSearchResponse, column: ColumnData, p: NgbPopover, row: number, col: number) {
        // Check first if the cell is in edit mode and it is an editable column.
        // Do not show context menu when cell is in edit mode OR column is a Date type
        if (this.editingCell?.row !== row && this.editingCell?.col !== col && column.dataTypeCode !== 'D' && this.isColumnEditable(column)) {
            if (this.currentContextMenu) {
                this.currentContextMenu.close();
            }
            this.currentContextMenu = p;
            const model = this.getModel(column, entry);
            if (model && model.observationId) {
                this.currentContextMenuData = { row, col, model: model, entry, column };
                p.open();
            }
        }
    }

    checkOutOfBoundDraftData(): Promise<'ACCEPT_ALL' | 'SET_TO_MISSING' | 'NO_OUT_OF_BOUNDS'> {
        return new Promise((resolve, reject) => {
            this.datasetService.checkOutOfBoundDraftData(this.studyEditorContext.studyId, this.currentDataset.datasetId).toPromise().then(
                (response) => {
                    const modalInstance = this.openAcceptPendingModal();
                    modalInstance.then(resolve);
                },
                (errorResponse) => {
                    if (errorResponse.status === 404) {
                        return resolve('NO_OUT_OF_BOUNDS');
                    }
                }
            );
        });
    }

    acceptDraftData() {
        this.checkOutOfBoundDraftData().then((result) => {
            let promise: Promise<any>;

            if (result === 'ACCEPT_ALL' || result === 'NO_OUT_OF_BOUNDS') {
                promise = this.datasetService.acceptDraftData(this.studyEditorContext.studyId, this.currentDataset.datasetId, this.getInstanceIds()).toPromise();
            } else if (result === 'SET_TO_MISSING') {
                promise = this.datasetService.setAsMissingDraftData(this.studyEditorContext.studyId, this.currentDataset.datasetId, this.getInstanceIds()).toPromise();
            }

            if (promise) {
                promise
                    .then(() => {
                        this.checkPendingDataAndReload();
                        this.showWarningIfCalculatedVariablesAreOutOfSync();
                        this.alertService.success('study-editor.study-dataset.accept-pending-data.success', { param: this.getSelectedEnvironmentName() });
                    });
            }
        });
    }

    rejectDraftData() {
        const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
        confirmModalRef.componentInstance.message = this.translateService.instant('study-editor.study-dataset.discard-draft-data-confirm-message', { param: this.getSelectedEnvironmentName() });
        confirmModalRef.result.then(() => {
            this.datasetService.rejectDraftData(this.studyEditorContext.studyId, this.currentDataset.datasetId, this.getInstanceIds()).toPromise()
                .then(() => {
                    this.checkPendingDataAndReload();
                });
        });
    }

    openAcceptPendingModal() {
        const modalRef = this.modalService.open(AcceptPendingModalComponent);
        return modalRef.result.then((result: 'ACCEPT_ALL' | 'SET_TO_MISSING') => {
            if (result) {
                // Handle the selected option (ACCEPT_ALL or SET_TO_MISSING)
                return result;
            }
            return null;
        });
    }

    checkPendingDataAndReload() {
        // If the dataset has no pending data, reload the whole dataset tab
        this.datasetService.getDataset(this.studyEditorContext.studyId, this.currentDataset.datasetId).toPromise().then((response) => {
            this.currentDataset = response.body;
            this.studyEditorContext.updateDataset(this.currentDataset);
            this.isPendingView = this.currentDataset.hasPendingData;
            this.changeView(this.isPendingView);
        });
    }

    resetState() {
        this.cancellableSubscription.unsubscribeAll();
        this.selectedItems.clear();
        this.isSelectAll = false;
        this.displayedColumns = [];
        this.batchVariables = [];
        this.selectedBatchVariable = null;
        this.batchVariablesFilter = null;
        this.selectedStatusFilter = 1;
        this.selectedEnvironment = null;
        this.isPendingView = false;
        this.isCollapsedTraits = false;
        this.isCollapsedSelections = false;
        this.columnSelectorComponent?.resetToDefault();
    }

    getInstanceIds(): number[] {
        if (this.selectedEnvironment && this.selectedEnvironment.instanceId !== -1) {
            return [this.selectedEnvironment.instanceId];
        }
        return this.environments.map(env => env.instanceId).filter(id => id !== -1);
    }

    getSelectedEnvironmentName() {
        if (this.selectedEnvironment && this.selectedEnvironment.instanceId === -1) {
            return this.translateService.instant('study-editor.all-environments');
        } else if (this.selectedEnvironment && this.selectedEnvironment.instanceId !== -1) {
            return `${this.selectedEnvironment.instanceNumber} -${this.selectedEnvironment.locationName}`;
        }
    }

    /**
     * Displays the Execute Calculated Variable action menu if any of the datasets (plot and sub-observations)
     * in the current study has calculated traits.
     * If none of the datasets have calculated variables, Execute Calculated Variable action menu is hidden.
     */
    displayExecuteCalculateVariableMenu(studyId: number): void {
        this.cancellableSubscription.add = this.datasetService.getDatasetsWithoutMetadata(studyId, DATASET_TYPES_OBSERVATION_IDS).subscribe({
            next: (response) => {
                const datasets = response.body || [];
                const datasetIds = datasets.map(dataset => dataset.datasetId);

                if (datasetIds.length === 0) {
                    this.isStudyHasCalculatedVariables = false;
                    return;
                }

                this.cancellableSubscription.add = this.derivedVariableService.countCalculatedVariables(studyId, datasetIds).subscribe({
                    next: (countResponse) => {
                        const count = countResponse.headers.get('X-Total-Count');
                        const hasCalculatedVariable = parseInt(count || '0', 10) > 0;
                        this.isStudyHasCalculatedVariables = hasCalculatedVariable;
                        this.studyEditorContext.studyHasCalculatedVariables = hasCalculatedVariable;
                    }
                });
            }
        });
    }

    /**
     * Shows warning if dependencies are missing
     */
    showWarningIfDependenciesAreMissing(studyId: number, datasetId: number, variableId: number): void {
        this.derivedVariableService.getMissingFormulaVariables(studyId, datasetId, variableId).toPromise().then(
            (data: []) => {
                const missingFormulaVariables = data || [];

                if (missingFormulaVariables.length > 0) {
                    const missingFormulaVariablesNames = missingFormulaVariables.map(
                        (formulaVariable: any) => formulaVariable.name
                    );

                    this.alertService.warning('study-editor.study-dataset.calculated-variable-dependencies-are-missing-warning-message', { param: missingFormulaVariablesNames.join(', ') },
                        15000
                    );
                }
            });
    }

    /**
     * Shows warning if calculated variables are out of sync
     */
    showWarningIfCalculatedVariablesAreOutOfSync(): void {
        this.datasetService.getDatasetsWithoutMetadata(this.studyEditorContext.studyId, []).toPromise().then(
            (response) => {
                const datasets = response.body || [];
                const datasetsWithOutOfSyncData = datasets
                    .filter(dataset => dataset.hasOutOfSyncData)
                    .map(dataset => dataset.name);

                if (datasetsWithOutOfSyncData.length > 0) {
                    this.alertService.warning('study-editor.study-dataset.calculated-variable-out-of-sync-warning-message', { param: datasetsWithOutOfSyncData.join(', ') },
                        15000
                    );
                }
            });
    }

    dropColumn(event: CdkDragDrop<any[]>) {
        // Get indexes of selected columns only
        const selectedColumns = this.displayedColumns.filter(col => col.selected);
        const fromIndex = this.displayedColumns.findIndex(col => col === selectedColumns[event.previousIndex]);
        const toIndex = this.displayedColumns.findIndex(col => col === selectedColumns[event.currentIndex]);

        if (fromIndex !== -1 && toIndex !== -1) {
            moveItemInArray(this.displayedColumns, fromIndex, toIndex);
            this.columnDataService.saveColumnsState();
        }
    }

    editSubObsUnitsNumber() {
        const modalRef = this.modalService.open(UpdateSubObservationUnitNumberModalComponent as Component, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.selectedDatasetType = this.subObservationInfoModels.find(m => m.id === this.currentDataset.datasetTypeId);
        modalRef.componentInstance.selectedVariableId = this.currentDataset.variables.find(variable => this.subObservationVariables.includes(variable.termId)).termId;
        modalRef.componentInstance.datasetName = this.currentDataset.datasetName;
        modalRef.componentInstance.datasetId = this.currentDataset.datasetId;
        modalRef.result.then((result) => {
            this.studyEditorService.triggerRefreshAndWait().then(() => {
                this.studyEditorService.navigateToDatasetTab(this.studyEditorContext.studyId, this.currentDataset.datasetId);
            });
        }, () => modalRef.dismiss());

    }

    async deleteDataset() {
        const hasCalculatedTraits = await this.checkCalculatedTraits();
        const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
        if (hasCalculatedTraits) {
            confirmModalRef.componentInstance.message = this.translateService.instant('study-editor.study-dataset.delete-confirm-message-with-calculated-traits');
        } else {
            confirmModalRef.componentInstance.message = this.translateService.instant('study-editor.study-dataset.delete-confirm-message');
        }

        confirmModalRef.result.then(() => {
            this.datasetService.deleteDataset(this.studyEditorContext.studyId, this.currentDataset.datasetId).toPromise()
                .then(() => {
                    this.studyEditorService.triggerRefreshAndWait().then(() => {
                        this.studyEditorService.navigateToDatasetTab(this.studyEditorContext.studyId, this.studyEditorContext.getPlotDataset().datasetId);
                    });
                });
        });
    }

    showBatchActions() {
        return this.isPendingView && (this.principal.hasAnyAuthorityDirect(MANAGE_PENDING_OBSERVATION_VALUES_PERMISSIONS) || this.principal.hasAnyAuthorityDirect(MANAGE_ACCEPT_PENDING_OBSERVATION_VALUES_PERMISSIONS)) ||
            !this.isPendingView && this.principal.hasAnyAuthorityDirect(MANAGE_CONFIRMED_OBSERVATION_VALUES_PERMISSIONS);
    }

    validateSelection() {
        if (this.selectedItems.size === 0 && !this.isSelectAll) {
            this.alertService.error('study-editor.study-dataset.no-selected-observation-units-error');
            return false;
        }
        return true;
    }

    openLotCreationModal() {
        if (!this.validateSelection()) {
            return;
        }

        const filter = this.getFilter();
        filter.filteredNdExperimentIds = this.selectedItems.size ? Array.from(this.selectedItems) : null;

        const searchRequest: ObservationUnitsSearchRequest = {
            datasetId: this.currentDataset.datasetId,
            instanceIds: this.getInstanceIds(),
            draftMode: this.isPendingView,
            filter: filter
        };

        this.datasetService.saveSearchRequest(this.studyEditorContext.studyId, this.currentDataset.datasetId, searchRequest).toPromise().then((searchDto) => {
            const modalRef = this.modalService.open(LotCreationDialogComponent as Component, { size: 'lg', backdrop: 'static' });
            modalRef.componentInstance.searchRequestId = searchDto.searchResultDbId;
            modalRef.componentInstance.openedFromWorkbench = true;
            modalRef.componentInstance.searchOrigin = SearchOrigin.MANAGE_STUDY_PLOT;
            modalRef.componentInstance.initialDepositRequired = true;
            modalRef.componentInstance.showReuseSrcObsUnitToggle = false;
            modalRef.result.then((result) => {
                this.studyEditorService.triggerRefreshAndWait().then(() => {
                    this.studyEditorService.navigateToTab(this.studyEditorContext.studyId, 'inventory');
                });
            });
        });

    };

    openPlantingInventoryModal() {
        if (!this.validateSelection()) {
            return;
        }

        const modalRef = this.modalService.open(PlantingPreparationModalComponent as Component, { size: 'xxxl', backdrop: 'static' });
        modalRef.componentInstance.datasetId = this.currentDataset.datasetId;
        modalRef.componentInstance.studyId = this.studyEditorContext.studyId;
        modalRef.componentInstance.searchComposite = {
            itemIds: this.selectedItems.size ?  Array.from(this.selectedItems) : null,
            searchRequest: this.selectedItems.size ? null : {
                instanceIds: this.getInstanceIds(),
                draftMode: this.isPendingView,
                filter: this.getFilter()
            }
        };
        modalRef.result.then((result) => {
            this.scheduleTableDataReload(this.currentPage, this.pageSize);
        });
    }

    openChangePlotEntryModal() {
        if (!this.validateSelection()) {
            return;
        }

        const modalRef = this.modalService.open(ChangePlotEntryModalComponent as Component, { size: 'xxxl', backdrop: 'static' });
        modalRef.componentInstance.datasetId = this.currentDataset.datasetId;
        modalRef.componentInstance.searchComposite = {
            itemIds: this.selectedItems.size ?  Array.from(this.selectedItems) : null,
            searchRequest: this.selectedItems.size ? null : {
                instanceIds: this.getInstanceIds(),
                draftMode: this.isPendingView,
                filter: this.getFilter()
            }
        };
        modalRef.result.then((result) => {
            this.scheduleTableDataReload(this.currentPage, this.pageSize);
        });

    }

    private async checkCalculatedTraits() {
        const variables = new Set(this.currentDataset.variables.map(variable => variable.termId));
        // Retrieve all formula variables in study
        const responseData = await this.derivedVariableService.getFormulaVariables(this.studyEditorContext.studyId, this.studyEditorContext.getPlotDataset().datasetId).toPromise();
        //response is null if study is not yet saved
        if (responseData) {
            return responseData.some((formulaVar) => variables.has(formulaVar.id));
        }
        return false;
    };

    protected readonly DatasetTypeEnum = DatasetTypeEnum;

    selectAllChanged(isSelectAll: boolean) {
        this.isSelectAll = isSelectAll;
        const checkboxColumn = this.displayedColumns.find(col => col.termId === this.CHECKBOX);
        if (checkboxColumn) {
            checkboxColumn.visible = !isSelectAll;
        }
        if (this.isSelectAll) {
            this.selectedItems.clear();
        }
    }

    showFiles(observationUnitUUID: string, variableName?: string) {
        const modalRef = this.modalService.open(FileManagerComponent as Component, { size: 'xl', backdrop: 'static' });
        modalRef.componentInstance.datasetId = this.currentDataset.datasetId;
        modalRef.componentInstance.observationUnitUUID = observationUnitUUID;
        modalRef.componentInstance.variableName = variableName;
        modalRef.result.then((result) => {
            this.scheduleDatasetReload();
            this.scheduleReload();
        }, () => {
            this.scheduleDatasetReload();
            this.scheduleReload();
        });
    }

    onColumnSelectorDeselectedAll() {
        this.displayedColumns.forEach(column => {
            if (column.visible) {
                column.selected = false;
            }

        });
        this.scheduleReload();
    }

    onColumnSelectorSelectedAll() {
        this.displayedColumns.forEach(column => {
            if (column.visible) {
                column.selected = true;
            }
        });
        this.scheduleReload();
    }

    onColumnSelectorReset() {
        this.onColumnSelectorSelectedAll();
        this.scheduleReload();
    }

    onColumnSelectorClosed($event: { hasChanges: boolean }) {
        // When Column Selector dropdown is closed
        // Only relaod the table when there are changes in the column visibility/order
        if ($event && $event.hasChanges) {
            this.scheduleReload();
        }
    }

    clearFilters() {
        this.clearSelected();
        this.displayedColumns.forEach((column) => {
            this.resetFilterByColumn(column);
        });
    }

    openObservationDetails(observationUnitId: string) {
        const modalRef = this.modalService.open(ObservationDetailsModalComponent as Component, { size: 'xl', backdrop: 'static' });
        modalRef.componentInstance.datasetId = this.currentDataset.datasetId;
        modalRef.componentInstance.studyId = this.studyEditorContext.studyId;
        modalRef.componentInstance.observationUnitId = observationUnitId;
    }

    async detachOrDeleteFilesIfAny(variables: ObservationVariable[], variableTypeId: VariableTypeEnum) {
        const variableIds = variables.map(variable => variable.termId);

        const doContinue = await this.checkVariableHasMeasurementData(variableIds);
        if (!doContinue) {
            return;
        }

        if (this.isFileStorageConfigured) {
            const fileCountResp = await this.fileService.getFileCountStudy(variableIds, this.currentDataset.datasetId, null, null).toPromise();
            const fileCount = parseInt(fileCountResp.headers.get('X-Total-Count'), 10);
            if (fileCount > 0) {
                const modalInstance = this.showFileDeletionOptions(fileCount);
                modalInstance.result.then(() => {
                    this.fileService.removeFilesStudy(variableIds, this.currentDataset.datasetId, null).toPromise()
                        .then(() => {
                            this.removeVariables(variables, variableTypeId);
                        });
                }, () => {
                    this.fileService.detachFilesStudy(variableIds, this.currentDataset.datasetId, null).toPromise()
                        .then(() => {
                            this.removeVariables(variables, variableTypeId);
                        });
                });
            } else {
                this.removeVariables(variables, variableTypeId);
            }
        } else {
            this.removeVariables(variables, variableTypeId);
        }
    };

    async checkVariableHasMeasurementData(variableIds: number[]) {

        const isVariableUsedInOtherCalculatedVariable = await this.checkVariableIsUsedInCalculatedVariable(variableIds);

        if (variableIds.length !== 0) {
            const response = await this.datasetService.observationCount(this.studyEditorContext.studyId, this.currentDataset.datasetId, variableIds).toPromise();
            const count = parseInt(response.headers.get('X-Total-Count'), 10);
            if (count > 0) {
                // Show confirmation modal and handle user choice
                const modalRef = this.modalService.open(ModalConfirmComponent);
                modalRef.componentInstance.title = 'Confirmation';
                if (isVariableUsedInOtherCalculatedVariable) {
                    modalRef.componentInstance.message = this.translateService.instant('study-editor.study-dataset.delete-variable.variable-is-used-in-calculated-variable');
                } else {
                    modalRef.componentInstance.message = this.translateService.instant('study-editor.study-dataset.delete-variable.variable-has-measurement-data');
                }
                return modalRef.result
                    .then(() => true) // User confirms (true)
                    .catch(() => false); // User cancels (false)
            } else {
                return Promise.resolve(true); // Variables dont have data, return true to continue
            }
        }
        return Promise.resolve(true); // Variables dont have data, return true to continue
    };

    async checkVariableIsUsedInCalculatedVariable(variableIds: number[]) {
        let variableIsUsedInOtherCalculatedVariable = false;
        const responseData = await this.derivedVariableService.getFormulaVariables(this.studyEditorContext.studyId, this.studyEditorContext.getPlotDataset().datasetId).toPromise();
        //response is null if study is not yet saved
        if (responseData) {
            responseData.forEach((formulaVariable)=> {
                if (variableIds.indexOf(formulaVariable.id) > -1) {
                    variableIsUsedInOtherCalculatedVariable = true;
                }
            });
        }
        return variableIsUsedInOtherCalculatedVariable;
    };

    showFileDeletionOptions(fileCount: number) {
        const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
        confirmModalRef.componentInstance.message = this.translateService.instant('study-editor.file-delete-options.message', { param: fileCount });
        confirmModalRef.componentInstance.cancelLabel = this.translateService.instant('study-editor.file-delete-options.leave-them');
        confirmModalRef.componentInstance.confirmLabel = this.translateService.instant('study-editor.file-delete-options.delete-them');
        return confirmModalRef;
    };

    isFileButtonVisible(entry: ObservationUnitsSearchResponse): boolean {
        return this.isFileStorageConfigured && entry.fileCount > 0 && this.hasAnyAuthority(this.MANAGE_FILES_OBSERVATIONS_PERMISSION);
    }

    isFileButtonVisibleForVariable(entry: ObservationUnitsSearchResponse, variableId: string): boolean {
        return this.isFileStorageConfigured && entry.fileVariableIds?.includes(variableId) && this.hasAnyAuthority(this.MANAGE_FILES_OBSERVATIONS_PERMISSION);
    }

    setHoveredRow(index: number | null): void {
        this.hoveredRow = index;
    }

    openObservationSampleDetails(obsUnitId: string) {
        const modalRef = this.modalService.open(ObservationSampleDetailsModalComponent as Component, { size: 'xl', backdrop: 'static' });
        modalRef.componentInstance.obsUnitId = obsUnitId;
    }

    visualizePlotData() {
        const modalRef = this.modalService.open(PlotVisualizationModalComponent as Component, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.datasetId = this.currentDataset.datasetId;
        modalRef.componentInstance.studyId = this.studyEditorContext.studyId;
        modalRef.componentInstance.searchComposite = {
            itemIds: this.selectedItems.size ?  Array.from(this.selectedItems) : null,
            searchRequest: this.selectedItems.size ? null : {
                instanceIds: this.getInstanceIds(),
                draftMode: this.isPendingView,
                filter: this.getFilter()
            }
        };
    }

    hasGeneratedDesign() {
        return this.studyEditorContext.hasGeneratedDesign();
    }

    protected onSelectPage() {
        if (this.isPageSelected()) {
            // remove all items
            this.items.forEach((item) => this.selectedItems.delete(item.observationUnitId));
        } else {
            // check remaining items
            this.items.forEach((item) => this.selectedItems.add(item.observationUnitId));
        }
    }

    protected isPageSelected() {
        return this.selectedItems && this.selectedItems.size && this.items.every((item) => this.selectedItems.has(item.observationUnitId));
    }

    protected readonly VIEW_NAMES_PERMISSION = VIEW_NAMES_PERMISSION;
    protected readonly DomEvent = DomEvent;
}
